import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { HelperService } from 'src/app/services/helper.service';

// Landing screen for an SSO handoff from another app: /sso?q=<encrypted>.
// Exchanges q for a session via login-sso and then behaves exactly like a /login 200.
@Component({
    selector: 'app-sso',
    template: `<div class="text-center p-5">Signing you in…</div>`,
    standalone: false
})
export class SsoComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private helperService: HelperService) { }

  ngOnInit(): void {
    document.getElementsByTagName('body')[0].classList.add('grad-login');

    const q = this.route.snapshot.queryParamMap.get('q');
    if (!q) { this.router.navigate(['/login']); return; }

    // Wipe any existing session before the handoff, same as LoginComponent — this also stops
    // auth-interceptor.ts attaching a stale Authorization/role-id to the login-sso call.
    this.helperService.clearStorage();
    this.authService.isLoggedIn = false;

    this.authService.loginSso(q).then((res: any) => {
      // ApiService has already toasted anything that went wrong; just get out of the way.
      if (!this.authService.completeLoginNavigation(res)) { this.router.navigate(['/login']); }
    });
  }
}
